import { Box, Text } from '@factorialco/deprecated-design-system'
import { ItemIntegrationFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface supportAreaProps {
  integration: ItemIntegrationFragment
}

const FACTORIAL_DEVELOPER = 'Factorial'
export const FACTORIAL_SUPPORT_LINK =
  'https://portal.support.factorialhr.com/servicedesk/customer/portal/5/group/7/create/19'

const SupportArea = ({ integration }: supportAreaProps) => {
  const { developer, helpLink, supportLink } = integration

  const getContactSupportLink = () => {
    if (supportLink) return supportLink
    if (developer === FACTORIAL_DEVELOPER) return FACTORIAL_SUPPORT_LINK
  }
  const contactSupportLink = getContactSupportLink()

  return (
    <Box alignItems="flexStart" justifyContent="flexStart">
      <Box paddingBottom="s8">
        <Text size="400" weight="medium" color="grey1000">
          {i18n.t('marketplace.modules.support_area.title')}
        </Text>
      </Box>
      {contactSupportLink && (
        <a
          href={contactSupportLink}
          aria-label="contact-support-url"
          target="_blank"
          rel="nofollow noopener noreferrer"
        >
          <Text size="300" color="viridian1200">
            {i18n.t('marketplace.modules.support_area.contact_support')}
          </Text>
        </a>
      )}
      {helpLink && (
        <a
          href={helpLink}
          aria-label="help-page-url"
          target="_blank"
          rel="nofollow noopener noreferrer"
        >
          <Text size="300" color="viridian1200">
            {i18n.t('marketplace.modules.support_area.help_center')}
          </Text>
        </a>
      )}
    </Box>
  )
}

export default SupportArea
